<div class="container">
  <div class="container-table">
    <header class="top-header">
      <h3>Clusters</h3>
      <p>Manage dropdown value clusters</p>
    </header>

    <div class="tab-head">
      <div></div>
      <button (click)="createCluster()" class="btn-action">
        <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
        Create New
      </button>
    </div>

    <div class="responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cluster of clusters">
            <td>{{ cluster.name }}</td>
            <td>{{ cluster.description || '-' }}</td>
            <td>{{ cluster.is_active ? 'Active' : 'Inactive' }}</td>
            <td>
              <button class="action-button bt-edit" (click)="editCluster(cluster.id)" title="Edit">
                <fa-icon [icon]="['fas', 'pen']"></fa-icon>
              </button>
              <button class="action-button bt-delete" (click)="deleteCluster(cluster.id)" title="Delete">
                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="clusters.length === 0">
            <td colspan="4">No clusters found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
